import React, { useState } from 'react';
import { Button, ButtonProps } from 'antd';

export type ActionButtonProps = Omit<ButtonProps, 'onClick' | 'loading'> & {
  onClick?: (event: React.MouseEvent<HTMLElement>) => void | Promise<void>;
  loading?: boolean;
};

const ActionButton: React.FC<ActionButtonProps> = ({
  onClick,
  loading = false,
  disabled,
  children,
  ...props
}) => {
  const [busy, setBusy] = useState(false);
  const isLocked = loading || busy;

  const handleClick = async (event: React.MouseEvent<HTMLElement>) => {
    if (!onClick || isLocked || disabled) {
      return;
    }

    const result = onClick(event);
    if (result && typeof (result as Promise<void>).then === 'function') {
      setBusy(true);
      try {
        await result;
      } finally {
        setBusy(false);
      }
    }
  };

  return (
    <Button {...props} loading={isLocked} disabled={disabled || isLocked} onClick={handleClick}>
      {children}
    </Button>
  );
};

export default ActionButton;
